import { useQuery } from "@apollo/client";
import { Stack } from "@mui/material";
import { gql } from "generated-graphql";
import { ProgramArea } from "generated-graphql/graphql";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { getWasteBreadcrumb, getWasteContactsBreadcrumb } from "util/breadcrumb";
import { isRcraContactIssue } from "util/facilityContacts";

import { FacilityContacts } from "../../Contacts/FacilityContacts";

const GET_WASTE_FACILITY_CONTACTS = gql(`
  query GetWasteFacilityContacts($facilityId: ID!, $programArea: ProgramArea) {
    facility(id: $facilityId) {
      id
      name
      state
      ...facilityContacts
      issues {
        ...issue
      }
    }
  }
`);

export const WasteContacts = () => {
  const { tenantId, facilityId } = useParams();
  const { data, previousData } = useQuery(GET_WASTE_FACILITY_CONTACTS, {
    variables: {
      facilityId: facilityId ?? "",
      programArea: ProgramArea.Rcra,
    },
    skip: !facilityId,
    fetchPolicy: "cache-and-network",
  });
  const issues = useMemo(() => data?.facility?.issues ?? [], [data?.facility?.issues]);

  useBreadcrumb([
    {
      label: "Waste",
      to: tenantId ? getWasteBreadcrumb(tenantId) : undefined,
    },
    {
      label: "Contacts",
      to: tenantId ? getWasteContactsBreadcrumb(tenantId) : undefined,
    },
    {
      label: data?.facility?.name ?? "",
    },
  ]);

  return (
    <Stack sx={{ px: 3, pt: 4 }}>
      <FacilityContacts
        loading={!data && !previousData}
        facilityId={data?.facility?.id ?? ""}
        facilityState={data?.facility?.state ?? ""}
        facilityContacts={data?.facility?.contacts ?? []}
        getRowIssues={(row) =>
          issues.filter(
            (issue) =>
              ((issue.modelId === row.person.id && issue.modelName === "Person") ||
                (issue.modelName === "FacilityContact" && issue.modelId === row.id)) &&
              isRcraContactIssue(issue)
          )
        }
        facilityContactIssues={issues.filter(
          (issue) => issue.key === "contacts" && isRcraContactIssue(issue)
        )}
        refetchQueries={[GET_WASTE_FACILITY_CONTACTS]}
      />
    </Stack>
  );
};
